module.exports = __webpack_public_path__ + "static/media/skill_icon_kagerou.9d15f065.png";